import React from 'react'

export default function RiskGreenIcon({ width = 14, height = 16, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 16C4.97292 15.5333 3.29948 14.47 1.97969 12.81C0.659896 11.15 0 9.30667 0 7.28V2.4L7 0L14 2.4V7.28C14 9.30667 13.3401 11.15 12.0203 12.81C10.7005 14.47 9.02708 15.5333 7 16ZM7 14.32C8.51667 13.88 9.77083 13 10.7625 11.68C11.7542 10.36 12.25 8.89333 12.25 7.28V3.5L7 1.7L1.75 3.5V7.28C1.75 8.89333 2.24583 10.36 3.2375 11.68C4.22917 13 5.48333 13.88 7 14.32Z" fill="#04BA7D"/>
    </svg>
  )
}
